import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams, useNavigate } from "react-router-dom";
import TemporaryDrawer from "./TemporaryDrawer";
import NavBar from "./NavBar";
import CardIp from "./CardIp";
import CardOtt from "./CardOtt";
import CardCmot from "./CardCmot";
import CardDd from "./CardDd";
import LeftBar from "./LeftBar";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faDownload } from "@fortawesome/free-solid-svg-icons";
import Timer from "./Timer";
import CardCinemaAi from "./CardCinemaAi";

const Container = styled(Box)({
  height: "100%",
});

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && (
        <Grid sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Grid>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const tabNameToIndex = {
  ip: 0,
  ott: 1,
  cmot: 2,
  // "cinemai-hackathon": 3,
  // dd: 3,
};

const indexToTabName = {
  0: "ip",
  1: "ott",
  2: "cmot",
  // 3: "cinemai-hackathon",
};

const Dashboard = () => {
  const { tabName } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = useState(tabNameToIndex[tabName] || 0);
  const [cardData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 760px)");
  useEffect(() => {
    if (tabName !== undefined) {
      setValue(tabNameToIndex[tabName]);
    }
  }, [tabName]);

  const handleChange = (event, newValue) => {
    // console.log({newValue});
    setValue(newValue);
    navigate(`/dashboard/${indexToTabName[newValue]}`);
    if (isSmallScreen) {
      setDrawerOpen(false);
    }
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleEditClick = (id) => {
    navigate(`/ip/${id}`);
  };
  // Ip Authorisation
  const authorization_letter_english = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Authorization%20Letter%20(Form%20IP%202),%20IP%202026.pdf`;
  const declaration_file_english = `${process.env.REACT_APP_BASE_URL}/assets/pdf/8.2c%20Declaration,%20IP%202026.pdf`;
  const regulation_file_english = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Indian%20Panorama%20Regulations%20(2026).pdf`;
  const guidelines_of_accessibility = `${process.env.REACT_APP_BASE_URL}/assets/pdf/GUIDELINES%20OF%20ACCESSIBILITY%20STANDARDS%20IN%20THE%20PUBLIC%20EXHIBITION%20OF%20FEATURE%20FILMS%20IN%20CINEMA%20THEATRES%20FOR%20PERSONS%20WITH%20HEARING%20AND%20VISUAL%20IMPAIRMENT.pdf`;
  const EnglishRegulation = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Best%20Web%20Series%20(OTT)%20Award%20Regulations%20(2026).pdf`;
  const ScheduleDeclerationLettet = `${process.env.REACT_APP_BASE_URL}/assets/pdf/SCHEDULE%20I%20-%20Best%20Web%20Series%20(OTT),%202026.pdf`;

  // const regulation_file_hindi = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Regulations_IP_hindi_24.pdf`;
  // const authorization_letter_hindi = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Authorisation_Letter_IP_24_Hindi new.pdf`;
  // const declaration_file_hindi = `${process.env.REACT_APP_BASE_URL}/assets/pdf/DeclarationHindi_2024.pdf`;

  const regulation_file_english_CMOT = `${process.env.REACT_APP_BASE_URL}/assets/pdf/CMOT Application Eligibility Criteria.pdf`;

  const regulation_file_english_DD = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Regulations_Best Debut_English.pdf`;
  // const regulation_file_hindi_DD = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Best Debut Indian Film Section 2024_ hindi.docx`;
  const authorization_file_english_DD = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Best Debut_Authorization Letter_English.pdf`;
  // const authorization_file_hindi_DD = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Authorisation_Letter Debut.pdf`;
  const declaration_file_english_DD = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Best Debut_ Declaration_English.pdf`;
  // const declaration_file_hindi_DD = `${process.env.REACT_APP_BASE_URL}/assets/pdf/Best Debut_ Declaration_Hindi.docx.pdf`;

  const [impoData, setImpoData] = useState([]);
  let baseUrl = process.env.REACT_APP_BASE_PREFIX;
  useEffect(() => {
    const ImportantData = async () => {
      if (!baseUrl) {
        return;
      }
      try {
        console.log({ baseUrl })

        const response = await fetch(`${baseUrl}/AppData.json?t=${Date.now()}`);
        const commonData = await response.json();
        setImpoData(commonData);
      } catch (error) {
        console.error(error, "importent adta error");
      }
    };

    ImportantData();
  }, []);

  return (
    <Container>
      <Grid container>
        {!isSmallScreen && (
          <Grid item md={2} sm={3} xs={12}>
            {/* Sidebar */}
            <LeftBar
              drawerOpen={drawerOpen}
              handleDrawerToggle={handleDrawerToggle}
              handleChange={handleChange}
              value={value}
              isSmallScreen={isSmallScreen}
            />
          </Grid>
        )}

        {/* Content Area */}
        <Grid
          item
          md={isSmallScreen ? 12 : 10}
          sm={isSmallScreen ? 12 : 9}
          xs={12}
        >
          <NavBar onMenuToggle={handleDrawerToggle} activeTab={value} />

          {isSmallScreen && (
            <TemporaryDrawer
              drawerOpen={drawerOpen}
              handleDrawerToggle={handleDrawerToggle}
              handleChange={handleChange}
              value={value}
              isSmallScreen={isSmallScreen}
            />
          )}

          {/* Indian Panorama */}
          <TabPanel value={value} index={0}>
            <div className="Countdown">
              {/* {impoData} */}
              {impoData ? (
                <Timer
                  lastDate={impoData?.indian_Peronoma?.last_date}
                  lastTime={impoData?.indian_Peronoma?.last_time}
                  startMessage={`Last Date Of Online Form Submission is ${impoData?.indian_Peronoma?.last_date} till ${impoData?.indian_Peronoma?.last_time}`}
                  endMessage="Deadline for form submission are closed now!"
                  noteMessage={`If you have completed your submission before ${impoData?.indian_Peronoma?.last_date} till ${impoData?.indian_Peronoma?.last_time} and your payment confirmation is still pending, don't worry—we'll confirm it within the next 24 hours.Stay tuned!`}
                />
              ) : (
                <></>
              )}
            </div>
            <div className="top_head">
              <h3>Indian Panorama</h3>
            </div>
            <div>
              <CardIp
                cardData={cardData}
                impoData={impoData}
                onEditClick={handleEditClick}
              />
            </div>
            <div className="card_con mt-4">
              <h5 className="mt-2">
                {`Regulations of Indian Panorama ${impoData.award_year}`}
              </h5>
              <div className="pdf-links">
                <a
                  href={regulation_file_english}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
                {/* <a
                  href={regulation_file_hindi}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  Hindi <FontAwesomeIcon icon={faDownload} />
                </a> */}
              </div>
              <div className="important-notes">
                <h5>Important Notes:</h5>
                <ul>
                  <li>
                    {`
                    Applicants are requested to carefully read the Regulations
                    of Indian Panorama ${impoData.award_year} before submission of entries.`}
                  </li>
                  <li>
                    Last date for submission of ONLINE applications is{" "}
                    <b>
                      {impoData?.["indian_Peronoma"]?.["last_date"]} till{" "}
                      {impoData?.["indian_Peronoma"]?.["last_time"]}
                    </b>
                    .
                  </li>
                  <li>
                    Last date for receipt of the hard copy of the submitted
                    online application form along with the requisite documents
                    and materials is{" "}
                    <b>
                      {impoData?.["indian_Peronoma"]?.["last_document"]} till{" "}
                      {impoData?.["indian_Peronoma"]?.["last_time"]}
                    </b>
                    .
                  </li>
                </ul>
              </div>
              <hr />
              <h5 className="mt-4">
                GUIDELINES OF ACCESSIBILITY STANDARDS IN THE PUBLIC EXHIBITION OF FEATURE FILMS IN CINEMA THEATRES FOR PERSONS WITH HEARING AND VISUAL IMPAIRMENT
              </h5>
              <div className="pdf-links">
                <a
                  href={guidelines_of_accessibility}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
                {/* <a
                  href={authorization_letter_hindi}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  Hindi <FontAwesomeIcon icon={faDownload} />
                </a> */}
              </div>
              <h5 className="mt-4">
                Authorization Letter for NFDC (Form IP-II)
              </h5>
              <div className="pdf-links">
                <a
                  href={authorization_letter_english}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
                {/* <a
                  href={authorization_letter_hindi}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  Hindi <FontAwesomeIcon icon={faDownload} />
                </a> */}
              </div>
              <hr />
              <h5 className="mt-4">Declaration 8.2(c)</h5>
              <div className="pdf-links">
                <a
                  href={declaration_file_english}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
                {/* <a
                  href={declaration_file_hindi}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  Hindi <FontAwesomeIcon icon={faDownload} />
                </a> */}
              </div>
              <div className="important-notes">
                <h5>Important Note:</h5>
                <ul>
                  <li>
                    It is mandatory to register the film entry online, and
                    submit the application form and entry fee online only. Two
                    copies of the final submitted online application forms are
                    to be duly signed and stamped by the producer sent to NFDC
                    by post along with the requisite documents and material.
                  </li>
                </ul>
              </div>
              <hr />
              <h5 className="mt-4">
                Connect to us for any technical assistance for online
                entry form fillup :
              </h5>

              {/* <h6><b>Email:</b> <a href="mailto:indianpanoramatechnical@nfdcindia.com">indianpanoramatechnical@nfdcindia.com</a></h6> */}
              <h6>
                <b>Email:</b>
                <a href={`mailto: ${impoData?.digital_email}`}>
                  {" "}
                  {impoData?.digital_email}
                </a>
              </h6>
              {/* <h6>
                <b>Contact Number:</b> {impoData?.digital_phone}
              </h6> */}
              <h5 className="mt-4">
                Connect to us for any general query or question(s) :
              </h5>
              <h6>
                <b>Contact Number:</b> {impoData?.["indian_Peronoma"]?.phone}
              </h6>
              <h6>
                <b>Email:</b>{" "}
                <a href={`mailto: ${impoData?.["indian_Peronoma"]?.email}`}>
                  {impoData?.["indian_Peronoma"]?.email}
                </a>
              </h6>
              <h6>
                <b>Address: </b> National Film Development Corporation, Ministry
                of Information and Broadcasting, Government of India, NFDC - FD
                Complex, 1st Floor, Old Building 24, Dr. Gopalrao Deshmukh Marg,
                Mumbai 400026, Maharashtra
              </h6>
            </div>
          </TabPanel>

          {/* Best Web Series (OTT) Award, */}
          <TabPanel value={value} index={1}>
            {/* <h3>Web Series (OTT)</h3> */}
            <div className="Countdown">
              <Timer
                lastDate={impoData?.ott?.last_date}
                lastTime={impoData?.ott?.last_time}
                startMessage={`Last Date Of Online Form Submission is ${impoData?.ott?.last_date} till ${impoData?.ott?.last_time}`}
                endMessage="Deadline for form submission are closed now!"
                noteMessage={`If you have completed your submission before ${impoData?.ott?.last_date} till ${impoData?.ott?.last_time} and your payment confirmation is still pending, don't worry—we'll confirm it within the next 24 hours.Stay tuned!`}
              />
            </div>

            <div className="top_head">
              <h3>Best Web Series (OTT) Award, {impoData?.award_year}</h3>
            </div>
            <div>
              <CardOtt
                cardData={cardData}
                impoData={impoData}
                onEditClick={handleEditClick}
              />
            </div>
            <div className="card_con mt-4">
              <h5 className="mt-2">
                Regulations of Best Web Series (OTT) Award{" "}
                {impoData?.award_year}
              </h5>
              <div className="pdf-links">
                <a
                  href={EnglishRegulation}
                  target="_blank"
                  download
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
              </div>
              <h5 className="mt-2">Schedule 1 Declaration  Letter</h5>
              <div className="pdf-links">
                <a
                  href={ScheduleDeclerationLettet}
                  target="_blank"
                  download
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
              </div>
              <div className="important-notes">
                <h5>Important Notes:</h5>
                <ul>
                  <li>
                    Applicants are requested to carefully read the Regulations
                    of Best Web Series (OTT) Award {impoData?.award_year} before
                    submission of entries.
                  </li>
                  <li>
                    Last date for submission of ONLINE applications is
                    <b>
                      {" "}
                      {impoData?.["ott"]?.["last_date"]} till{" "}
                      {impoData?.["ott"]?.["last_time"]}
                    </b>
                  </li>
                  <li>
                    Last date for receipt of the hard copy of the submitted
                    online application form along with the requisite documents
                    is{" "}
                    <b>
                      {impoData?.["ott"]?.["last_document"]} till{" "}
                      {impoData?.["ott"]?.["last_time"]}
                    </b>
                  </li>
                </ul>
              </div>
              <hr />
              <h5 className="mt-4">
                Connect to us for any technical assistance for online
                entry form fillup :
              </h5>
              <h6>
                <b>Email:</b>
                <a href={`mailto: ${impoData?.digital_email}`}>
                  {" "}
                  {impoData?.digital_email}
                </a>
              </h6>
              {/* <h6>
                <b>Contact Number:</b> {impoData?.digital_phone}
              </h6> */}
              <h5 className="mt-4">
                Connect to us for any general query or question(s) :
              </h5>
              <h6>
                <b>Contact Number:</b> {impoData?.["ott"]?.phone}
              </h6>
              <h6>
                <b>Email:</b>{" "}
                <a href={`mailto: ${impoData?.["ott"]?.email}`}>
                  {impoData?.["ott"]?.email}
                </a>
              </h6>
              <h6>
                <b>Address:</b> National Film Development Corporation, Ministry
                of Information and Broadcasting, Government of India, NFDC - FD
                Complex, 1st Floor, Old Building 24, Dr. Gopalrao Deshmukh Marg,
                Mumbai 400026, Maharashtra
              </h6>
            </div>
          </TabPanel>

          {/* Creative Minds of Tomorrow */}
          <TabPanel value={value} index={2}>
            <div className="Countdown">
              <Timer
                lastDate={impoData?.cmot?.last_date}
                lastTime={impoData?.cmot?.last_time}
                startMessage={`Last Date Of Online Form Submission is ${impoData?.cmot?.last_date} till ${impoData?.cmot?.last_time}`}
                endMessage="Deadline for form submission are closed now!"
                noteMessage={`If you have completed your submission before ${impoData?.cmot?.last_date} till ${impoData?.cmot?.last_time} and your payment confirmation is still pending, don't worry—we'll confirm it within the next 24 hours.Stay tuned!`}
              />
            </div>
            <div className="top_head">
              <h3>Creative Minds of Tomorrow</h3>
            </div>
            <div>
              <CardCmot
                cardData={cardData}
                impoData={impoData}
                onEditClick={handleEditClick}
              />
            </div>
            <div className="card_con mt-4">
              <h5 className="mt-2">
                {`Regulations of Creative Minds of Tomorrow ${impoData.award_year}`}
              </h5>
              <div className="pdf-links">
                <a
                  href={regulation_file_english_CMOT}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />{" "}
                  English <FontAwesomeIcon icon={faDownload} />
                </a>
              </div>
              <div className="important-notes">
                <h5>Important Notes:</h5>
                <ul>
                  <li>The applicant should be an Indian Citizen.</li>
                  <li>The applicant must be born on or after July 1, 1991.</li>
                  <li>
                    The total running time of the film/ showreel/ song file to
                    be submitted should not be more than 10 minutes.
                  </li>
                  <li>
                    Regional films being submitted must be subtitled in English.
                  </li>
                  <li>
                    Participants selected in the earlier editions of the ‘
                    Creative Minds of Tomorrow’ are not eligible to apply in the
                    current edition of the programme.
                  </li>
                  <li>
                    Two people cannot apply with the same film submission in the
                    same category/film craft unless they are
                    co-directors/co-writers.
                  </li>
                  <li>
                    Credits of the film proving the candidates’ participation
                    need to be included in the final film uploaded for
                    verification of eligibility.
                  </li>
                </ul>
              </div>
              <hr />
              <div className="important-notes">
                <h5>Kindly Note:</h5>
                <ul>
                  <li>
                    {" "}
                    Please exercise great caution and verify the information
                    before submitting. Applications once submitted cannot be
                    edited and the form cannot be submitted twice.
                  </li>
                  <li>
                    {" "}
                    Kindly ensure that the name submitted in the application
                    form tallies with the credit titles appearing in the
                    submitted film.
                  </li>
                  <li>
                    {" "}
                    The last date of applying is{" "}
                    <b>
                      {impoData?.["cmot"]?.["last_document"]} till{" "}
                      {impoData?.["cmot"]?.["last_time"]}
                    </b>
                    .
                  </li>
                </ul>
              </div>
              <hr />
              <>
                <h5 className="mt-4">
                  Connect to us for any general query or question(s) :
                </h5>
                {impoData?.["cmot"]?.email ? (
                  <>
                    <h6>
                      <b>Email:</b>{" "}
                      <a href={`mailto: ${impoData?.["cmot"]?.email}`}>
                        {impoData?.["cmot"]?.email}
                      </a>
                    </h6>
                  </>
                ) : (
                  <></>
                )}

                {impoData?.["cmot"]?.phone ? (
                  <>
                    <h6>
                      <b>Contact Number:</b> {impoData?.["cmot"]?.phone}
                    </h6>
                  </>
                ) : (
                  <></>
                )}
              </>
              <h5 className="mt-4">
                Connect to us for any technical assistance for online
                entry form fillup :
              </h5>

              {/* <h6><b>Email:</b> <a href="mailto:indianpanoramatechnical@nfdcindia.com">indianpanoramatechnical@nfdcindia.com</a></h6> */}
              {impoData?.digital_email ? (
                <>
                  <h6>
                    <b>Email:</b>
                    <a href={`mailto: ${impoData?.digital_email}`}>
                      {" "}
                      {impoData?.digital_email}
                    </a>
                  </h6>
                </>
              ) : (
                <></>
              )}

              {impoData?.digital_phone ? (
                <>
                  <h6>
                    <b>Contact Number:</b> {impoData?.digital_phone}
                  </h6>
                </>
              ) : (
                <></>
              )}
            </div>
          </TabPanel>

          {/* CinemAI Hackathon: Pre-Evaluation Submission Foram */}
          <TabPanel value={value} index={3}>
            <div className="Countdown">
              <Timer
                lastDate={impoData?.cinema?.last_date}
                lastTime={impoData?.cinema?.last_time}
                startMessage={`Last Date Of Online Form Submission is ${impoData?.cinema?.last_date} till ${impoData?.cinema?.last_time}`}
                endMessage="Deadline for form submission are closed now!"
                noteMessage={`If you have completed your submission before ${impoData?.cinema?.last_date} till ${impoData?.cinema?.last_time} and your payment confirmation is still pending, don't worry—we'll confirm it within the next 24 hours.Stay tuned!`}
              />
            </div>
            <div className="top_head">
              <h3>CinemAI Hackathon: Pre-Evaluation Submission Form</h3>
            </div>
            <div>
              <CardCinemaAi
                cardData={cardData}
                impoData={impoData}
                onEditClick={handleEditClick}
              />
            </div>
            <div className="card_con mt-4">
              <h5 className="mt-2">
                {`CinemAI Hackathon: AI Film Festival & Hackathon - IFFI 2025`}
              </h5>

              <div className="important-notes">
                <p>
                  NFDC is organizing an Artificial Intelligence (AI) Film Festival and CinemAI Hackathon
                  during IFFI 2025 in collaboration with L&T Mindtree (LTIM). LTIM is collaborating with
                  IFFI to launch the first-ever AI Film Festival and Hackathon as part of the 56th edition
                  of IFFI, scheduled to be held in Goa, India, from November 20–28, 2025.
                </p>
              </div>

              <div className="important-notes mt-4">
                <h5>About CinemAI Hackathon</h5>
                <p>
                  The CinemAI Hackathon is a two-stage creative technology challenge celebrating innovation
                  in storytelling and filmmaking through Artificial Intelligence. It aims to bring together
                  filmmakers, artists, designers, and technologists to explore new cinematic languages enabled by AI.
                </p>
              </div>

              <div className="important-notes mt-4">
                <h5>Eligibility</h5>
                <ul>
                  <li>Open to individuals or teams (max 4-6 members) across the globe</li>
                  <li>Application submission for Pre-evaluation and the 48-Hour Hackathon shall be conducted online</li>
                  <li>Submissions must include usage of at least one AI tools for Video Generation</li>
                  <li>Participants must be 18 years or older</li>
                </ul>
              </div>

              <div className="important-notes mt-4">
                <h5>Entry Dates & Stages</h5>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Stage</th>
                        <th>Description</th>
                        <th>Dates</th>
                        <th>Submission Format and Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>Stage 1: Pre-Evaluation</strong></td>
                        <td>Submission of previously created AI-based content (2–5 minutes)</td>
                        <td>27th October to 10th November (15 days)<br />Shortlisted Teams will be announced on 15th November</td>
                        <td>Waves Bazaar Portal</td>
                      </tr>
                      <tr>
                        <td><strong>Stage 2: 48-Hour Hackathon</strong></td>
                        <td>Conceptualize, produce, and edit a short film (1 to 2 minutes) entirely with AI in 48 hours around a theme revealed at the start of the event</td>
                        <td>Nov 20–21, 2025<br />Winners to be announced on 24th</td>
                        <td>Waves Bazaar Portal</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="important-notes mt-4">
                <h5>Stage 1 – Pre-Evaluation</h5>
                <p>Participants submit previously created AI-assisted content.</p>

                <h6>Submission Requirements:</h6>
                <ul>
                  <li>A previously created AI-generated short film / video (2–5 minutes)</li>
                  <li>A Creative Note (max 250 words) including:
                    <ul>
                      <li>Film concept and intent</li>
                      <li>AI tools used (e.g., Runway, Pika, OpenAI, Midjourney, ElevenLabs, Adobe, and more)</li>
                      <li>Creative process & originality statement</li>
                    </ul>
                  </li>
                </ul>

                <h6>Judging Criteria:</h6>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Criterion</th>
                        <th>Description</th>
                        <th>Weight</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>Creativity & Originality</strong></td>
                        <td>Uniqueness of concept and storytelling</td>
                        <td>40%</td>
                      </tr>
                      <tr>
                        <td><strong>Use of AI Tools</strong></td>
                        <td>Depth and innovation in use of AI for Scripting, Generation, Editing, or Enhancement</td>
                        <td>40%</td>
                      </tr>
                      <tr>
                        <td><strong>Technical Execution</strong></td>
                        <td>Visual quality, sound, and production polish</td>
                        <td>20%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p><strong>Top 10 Teams will be shortlisted for the final 48-hour hackathon</strong></p>
              </div>

              <div className="important-notes mt-4">
                <h5>Stage 2 – 48-Hour Hackathon</h5>
                <p>Shortlisted Individuals/Teams to conceptualize, produce, and edit a short film (1 to 2 minutes) entirely with AI in 48 hours around a theme revealed at the start of the event.</p>

                <h6>Format:</h6>
                <ul>
                  <li>The theme will be revealed on Nov 20, 2025, at the Film Bazaar (Film Market) / Online</li>
                  <li>Participants will ideate, script, generate, and edit their films using AI tools within 48 hours</li>
                  <li>Participants are expected to reveal AI tools used during the Hackathon</li>
                  <li>Mentors from LTIM, OpenAI, and the film industry will guide creative and ethical use of AI</li>
                </ul>

                <h6>Evaluation Criteria:</h6>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Criterion</th>
                        <th>Description</th>
                        <th>Weight</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>Creativity & Storytelling</strong></td>
                        <td>Originality, coherence, emotional depth</td>
                        <td>30%</td>
                      </tr>
                      <tr>
                        <td><strong>Innovation in AI Use</strong></td>
                        <td>Creative integration of AI across production stages</td>
                        <td>30%</td>
                      </tr>
                      <tr>
                        <td><strong>Visual & Audio Quality</strong></td>
                        <td>Craft, design, and sensory impact</td>
                        <td>25%</td>
                      </tr>
                      <tr>
                        <td><strong>Execution Under Constraint</strong></td>
                        <td>Quality achieved within 48-hour limit</td>
                        <td>15%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="important-notes mt-4">
                <h5>Rules & Conditions</h5>
                <ul>
                  <li>All work must be original and created by the submitting team. Plagiarism or uncredited AI content will lead to disqualification.</li>
                  <li>Teams must transparently list all AI tools and models used.</li>
                  <li>Entries must not include hate speech, explicit content, political propaganda, or any copyrighted material without permission.</li>
                  <li>All final films must be conceptualized and produced within the 48-hour hackathon window.</li>
                  <li>Final films must be between 60–120 seconds in length, in MP4 / MOV format, 16:9 aspect ratio, HD (1080p).</li>
                  <li>Maximum 4 members; cross-disciplinary teams are encouraged.</li>
                  <li>The Jury will include AI technologists, filmmakers, and creative leaders from LTIM and NFDC</li>
                  <li>By submitting, participants grant LTIM, NFDC, and IFFI exclusive rights to screen and promote their work at the festival and related showcases.</li>
                  <li>LTIM will retain the final rights and ownership of all content created during the 48-Hour Hackathon.</li>
                  <li>Participants must uphold ethical standards in AI usage — respecting consent, bias mitigation, and responsible storytelling.</li>
                </ul>
              </div>

              <div className="important-notes mt-4">
                <h5>Submission Guidelines</h5>
                <p><strong>For Stage 1:</strong></p>
                <p>Submit via the official Waves Bazaar Portal</p>
                <ul>
                  <li>Video file link or upload</li>
                  <li>Creative note (PDF or text format)</li>
                  <li>Team details and contact information</li>
                </ul>

                <p><strong>For Stage 2:</strong></p>
                <ul>
                  <li>Submissions to be uploaded within 48 hours of theme release.</li>
                </ul>
              </div>

              <div className="important-notes mt-4">
                <h5>Recognition & Awards</h5>
                <ul>
                  <li><strong>CinemAI Grand Prize</strong> – Best Overall AI Film</li>
                  <li><strong>Category Awards:</strong>
                    <ul>
                      <li>Best Storytelling</li>
                      <li>Best Visuals</li>
                      <li>Best Sound / Music Design</li>
                      <li>Most Innovative Use of AI</li>
                      <li>Audience Choice Award</li>
                    </ul>
                  </li>
                </ul>
                <p>Winning films will be premiered at IFFI Goa and featured across LTIM, NFDC, and OpenAI platforms.</p>
              </div>

              <hr />

              <div className="important-notes">
                <h5>Connect to us for any general query or question(s):</h5>
                {impoData?.["cinema"]?.email ? (
                  <h6>
                    <b>Email:</b>{" "}
                    <a href={`mailto: ${impoData?.["cinema"]?.email}`}>
                      {impoData?.["cinema"]?.email}
                    </a>
                  </h6>
                ) : null}

                {impoData?.["cinema"]?.phone ? (
                  <h6>
                    <b>Contact Number:</b> {impoData?.["cinema"]?.phone}
                  </h6>
                ) : null}
              </div>

              <h5 className="mt-4">
                Connect to us for any technical assistance for online entry form fillup:
              </h5>

              {impoData?.digital_email ? (
                <h6>
                  <b>Email:</b>
                  <a href={`mailto: ${impoData?.digital_email}`}>
                    {" "}
                    {impoData?.digital_email}
                  </a>
                </h6>
              ) : null}

              {impoData?.digital_phone ? (
                <h6>
                  <b>Contact Number:</b> {impoData?.digital_phone}
                </h6>
              ) : null}
            </div>
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;
